<template lang="pug">
#delete-account-modal.modal.fade(
  aria-hidden='true'
  data-bs-backdrop='static'
  data-bs-keyboard='false'
  ref='modalRef'
  role='dialog'
  tabindex='-1'
)
  .modal-dialog.modal-dialog-centered.modal-lg(role='document')
    .modal-content.delete-account-modal
      .modal-header.border-0
        h5.modal-title {{ $t('modal.deleteModal.deleteAccount') }}
      .modal-body
        p.text-muted {{ $t('modal.deleteModal.alert') }}
        .lgpd-box.d-flex
          .lgpd-box__icon
            icon(name='shield-halved')
          .lgpd-box__content
            strong.d-block.mb-2 {{ $t('modal.deleteModal.resumeLgpd') }}
            ul.mb-0
              li {{ $t('modal.deleteModal.resumeLgpdText.message1') }}
              li {{ $t('modal.deleteModal.resumeLgpdText.message2') }}
              li {{ $t('modal.deleteModal.resumeLgpdText.message3') }}
              li {{ $t('modal.deleteModal.resumeLgpdText.message4') }}
        p.mt-3.mb-1 {{ $t('modal.deleteModal.forDetails') }}
        a.lgpd-link(
          :href='`${linkBase}/lgpd-and-exclusion-terms`'
          rel='noopener noreferrer'
          target='_blank'
        )
          icon.me-1(name='arrow-up-right-from-square')
          span {{ $t('modal.deleteModal.spanTermText') }}
        .form-check.mt-3
          input#accept-lgpd.form-check-input(
            type='checkbox'
            v-model='accepted'
          )
          label.form-check-label(for='accept-lgpd') {{ $t('modal.deleteModal.checkBoxMessage') }}
      .modal-footer.border-0
        button.btn.btn-outline-secondary(
          @click='resetState'
          data-bs-dismiss='modal'
          type='button'
        ) {{ $t('button.cancel') }}
        button.btn.btn-primary(
          :disabled='!accepted'
          @click='nextModalStep'
          data-bs-dismiss='modal'
          type='button'
        ) {{ $t('button.continue') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import ApplicationService from '@/services/ApplicationService';

export default {
  name: 'DeleteAccountModal',
  components: {
    Icon,
  },
  data() {
    return {
      accepted: false,
    };
  },
  computed: {
    linkBase() {
      return ApplicationService.getAuthorizationLinkBase(this.$i18n.locale);
    },
  },
  mounted() {
    this.$refs.modalRef.addEventListener('hidden.bs.modal', this.resetState);
  },
  beforeUnmount() {
    this.$refs.modalRef.removeEventListener('hidden.bs.modal', this.resetState);
  },
  methods: {
    resetState() {
      this.accepted = false;
    },
    nextModalStep() {
      this.$emit('continue');
    },
  },
};
</script>

<style lang="stylus">
.delete-account-modal
  .lgpd-box
    background-color: #FFF8E6
    border: 1px solid #FDECC8
    border-radius: 8px
    padding: 1rem
    gap: 0.75rem
  .lgpd-box__icon
    color: #E0A800
    flex-shrink: 0
  .lgpd-box__content
    strong
  color: #013D52
  ul
    padding-left: 1.1rem
</style>
